import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import GooglePlusHelper from "models/helper/GooglePlusHelper";
import SignupIntentHelper from "models/helper/SignupIntentHelper";
import { INLINE_AUTH_MODES } from "models/helper/InlineAuthModes";
import Utils from "models/helper/Utils";
import pageTemplate from 'text!../../../templates/SignUp/SignUpPageTemplate.html';
import ti18n from "i18n!nls/signupPagei18n";
import RSVP from "rsvp";
import Mousetrap from 'mousetrap';

const DISABLE_PASSWORD_CONFIRM = true;
const USE_NEW_GOOGE_API_ON_WEB = true;
const SignUpPageView = Backbone.View.extend({

    template : _.template(pageTemplate),

    initialize : function(options) {
        this._removeOnHide = true;
        this.isUserpreviouslyLoggedInAsGuest = options? options.isUserpreviouslyLoggedInAsGuest: false;
        this._accessCode = options? options.accessCode: null;
        this._manualAccessCodeOverride = false;
        this._defaultSignupIntent = options ? options.defaultSignupIntent : null;
        if(this._accessCode == "undefined"){
            this._accessCode = null;
        }
        if(!this._defaultSignupIntent){
            this._defaultSignupIntent = SignupIntentHelper.getDefaultSignupIntentForCurrentSurface();
        }
        if(!this._accessCode){
            this._accessCode = SignupIntentHelper.getDefaultAccessCodeForSignupIntent(this._defaultSignupIntent);
        }
        this._hideBackButton = options? options.hideBackButton : false;
        this._loginForwardUrl = options? options.loginForwardUrl : null;
        this._showOrganizationLogin = options ? options.showOrganizationLogin : false;
        this._mousetrapObj = null;
        this._enabledColor = "var(--trebble-primary)";
        this._disabledColor = "#cccccc";
        this._inlineAuthState = null;
    },

    shouldUseHostedSocialAuthButtons : function(){
        return Utils.getInstance().isBrowserHostedAuthEnvironment() || window.waitForCordovaToLoad;
    },

    shouldShowAppleAuthButtons : function(){
        return Utils.getInstance().shouldShowAppleAuthButtons();
    },

    isAccessCodeRequired : function(){
        return !!(
            typeof window !== "undefined" &&
            window.trebble &&
            window.trebble.requireAccessCodeOnSignup
        );
    },

    _getCurrentAccessCode : function(){
        const accessCodeValue = this.accessCodeField$el && this.accessCodeField$el.val ? this.accessCodeField$el.val() : null;
        if(!this._manualAccessCodeOverride && (!accessCodeValue || !accessCodeValue.toString().trim()) && this._accessCode){
            return this._accessCode;
        }

        if(typeof(accessCodeValue) != "string"){
            return null;
        }

        const trimmedAccessCode = accessCodeValue.trim();
        return trimmedAccessCode ? trimmedAccessCode : null;
    },

    _ensureManualAccessCodeEntryAction : function(){
        if(!this.accessCodeField$el || !this.accessCodeField$el.length){
            return null;
        }

        let manualEntryButton$el = this.$el.find("#showAccessCodeEntryBtn");
        if(!manualEntryButton$el.length){
            manualEntryButton$el = $('<a id="showAccessCodeEntryBtn" class="ui-link" data-testid="show-access-code-entry" style="display:none; text-align:center; margin:-6px auto 12px; font-size:12px; color:#4a4a4a;">' + window.getI18n(ti18n, "I_HAVE_AN_ACCESS_CODE") + '</a>');
            this._getAccessCodeFieldWrapper$el().after(manualEntryButton$el);
        }

        return manualEntryButton$el;
    },

    _getAccessCodeFieldWrapper$el : function(){
        if(!this.accessCodeField$el || !this.accessCodeField$el.length){
            return $();
        }

        const accessCodeFieldWrapper$el = this.$el.find("#accessCodeFieldDec");
        if(accessCodeFieldWrapper$el.length){
            return accessCodeFieldWrapper$el;
        }

        return this.accessCodeField$el.closest(".input-field");
    },

    _syncAccessCodeFieldVisibility : function(){
        if(!this.accessCodeField$el){
            return;
        }

        const accessCodeFieldWrapper$el = this._getAccessCodeFieldWrapper$el();
        const manualEntryButton$el = this._ensureManualAccessCodeEntryAction();
        const shouldShowManualEntryAction = !this.isAccessCodeRequired() && !!this._accessCode && !this._manualAccessCodeOverride;
        const shouldShowAccessCodeField = this.isAccessCodeRequired() || this._manualAccessCodeOverride || !this._accessCode;

        if(shouldShowAccessCodeField){
            if(this._manualAccessCodeOverride){
                if(this.accessCodeField$el.val() == this._accessCode){
                    this.accessCodeField$el.val("");
                }
            }else if(this._accessCode){
                this.accessCodeField$el.val(this._accessCode);
            }
            accessCodeFieldWrapper$el.show();
        }else{
            accessCodeFieldWrapper$el.hide();
        }

        if(manualEntryButton$el){
            manualEntryButton$el.toggle(shouldShowManualEntryAction);
        }
    },

    events : {
        "click #header-back-button" : "navigateToPreviousPage",
        "click #showAccessCodeEntryBtn" : "onShowAccessCodeEntryBtnTapped",
        "click #SignUpBtn.enabled" : "onSignUpBtnTapped",
        "click #SignUpWithFacebookBtn" : "onSignUpWithFacebookBtnTapped",
        "click #SignUpWithGoogleBtn" : "onSignUpWithGoogleBtnTapped",
        "click #SignUpWithAppleBtn" : "onSignUpWithAppleBtnTapped",
        "click #SignUpWithOrganizationBtn" : "onSignUpWithOrganizationBtnTapped",
        "click #showExternalSignupOptionsBtn": "onShowExternalSignupOptionsBtnTapped",
        "click .showExternalSignupOptionsBtn": "onShowExternalSignupOptionsBtnTapped",
        "click #signUpWithEmailBtn" : "onSignUpWithEmailBtn",
        "click #SignupInlineAuthPrimaryBtn.enabled" : "onInlineAuthPrimaryBtnTapped",
        "click #SignupInlineAuthSecondaryBtn" : "onInlineAuthSecondaryBtnTapped",
        "click #SignupInlineAuthEmailField, #SignupInlineAuthCodeField" : "onInlineAuthFieldChanged",
        "blur #SignupInlineAuthEmailField, #SignupInlineAuthCodeField" : "onInlineAuthFieldChanged",
        "keyup #SignupInlineAuthEmailField, #SignupInlineAuthCodeField" : "onInlineAuthFieldChanged",
        "input #SignupInlineAuthEmailField, #SignupInlineAuthCodeField" : "onInlineAuthFieldChanged",
    },

    onShowAccessCodeEntryBtnTapped : function(){
        this._manualAccessCodeOverride = true;
        if(this.accessCodeField$el){
            this.accessCodeField$el.val("");
        }
        this._syncAccessCodeFieldVisibility();
        this.onFieldValueChanged();
        if(this.accessCodeField$el){
            this.accessCodeField$el.focus();
        }
    },

    navigateToPreviousPage : function(){
        /*if(PersistentModels && PersistentModels.getInstance().getRouter()  ){
            PersistentModels.getInstance().getRouter().navigateToPreviousPage();
        }else{*/
            window.history.back();  
            //}

        },

        onSignUpBtnTapped : function(){

            const username  = this.usernameField$el.val();
            const password  =  this.newPassswordField$el.val();
            const email = this.emailField$el.val();
            //const firstName = this.firstNameField$el.val();
            //const lastName = this.lastNameField$el.val();
            const fullName = this.fullNameField$el.val();
            //const yearBirthday = this.$el.find("#yearBirthdayField").val();
            const accessCode = this._getCurrentAccessCode();
            const data = {};
            data.username =  username;
            data.password =  password;
            data.email =  email;
            //data.firstName =  firstName;
            //data.lastName =  lastName;
            data.fullName =  fullName;
            //data.yearOfBirth =  yearBirthday;
            if(accessCode){
                data.accessCode = accessCode;
            }
            this.trigger("signUpBtnTapped", data);
        },
        onSignUpWithFacebookBtnTapped: function(){
            this.trigger("signUpWithFacebookBtnTapped", this._getCurrentAccessCode());
        },

        onSignUpWithGoogleBtnTapped: function(event){
            if(this.shouldUseHostedSocialAuthButtons()){
                if(event){
                    event.preventDefault();
                }
                this.trigger("signUpWithGoogleBtnSuccess",null, this._getCurrentAccessCode());
            }
        },

        onSignUpWithAppleBtnTapped: function(){
            this.trigger("signUpWithAppleBtnTapped", this._getCurrentAccessCode());
        },
        onSignUpWithOrganizationBtnTapped : function(){
            this.trigger("signUpWithOrganizationBtnTapped");
        },
        onSignUpWithEmailBtn : function(){
            this.closeInlineAuthFlow();
            this.showOrHideSignupOptions(false);
        },

        onInlineAuthPrimaryBtnTapped : function(){
            if(!this._inlineAuthState){
                return;
            }

            this.trigger("signupInlineAuthSubmit", this.getInlineAuthData());
        },

        onInlineAuthSecondaryBtnTapped : function(){
            if(!this._inlineAuthState){
                return;
            }

            this.trigger("signupInlineAuthSecondaryAction", this.getInlineAuthData());
        },

        onShowExternalSignupOptionsBtnTapped : function(){
            this.closeInlineAuthFlow();
            this.showOrHideSignupOptions(true);
        },


        showOrHideSignupOptions : function(show){
            const fieldsToHideOrShow = "#usernameFieldDec, #emailDecorator, #passwordDecId, #fullNameFieldDec, #SignUpBtn"
            const useHostedSocialButtons = this.shouldUseHostedSocialAuthButtons();
            const shouldShowFacebookButton = !useHostedSocialButtons;
            const shouldShowAppleAuthButtons = this.shouldShowAppleAuthButtons();
            if(show){
                this.$el.find(fieldsToHideOrShow).hide();
                this.$el.find("#showExternalSignupInfoWrapper").hide();
                this.$el.find("#OrBlock").css("display","flex");
                this.$el.find("#signUpWithEmailBtn").css("display","block");
                this.$el.find("#SignUpWithFacebookBtn").css("display",shouldShowFacebookButton ? "flex" : "none");
                if(USE_NEW_GOOGE_API_ON_WEB && !useHostedSocialButtons){
                    this.$el.find(".google_button_container").css("display","flex");
                    this.$el.find("#SignUpWithGoogleBtn").hide();
                }else{
                    this.$el.find("#SignUpWithGoogleBtn").css("display","flex");
                    this.$el.find(".google_button_container").hide();
                }
                this.$el.find("#SignUpWithAppleBtn").css("display", shouldShowAppleAuthButtons ? "flex" : "none");
                if(this._showOrganizationLogin){
                    this.$el.find("#SignUpWithOrganizationBtn").css("display","flex");
                }
            }else{
                this.$el.find("#signUpWithEmailBtn").hide();
                this.$el.find("#OrBlock").hide();
                this.$el.find("#SignUpWithFacebookBtn").hide();
                this.$el.find(".google_button_container").hide();
                this.$el.find("#SignUpWithGoogleBtn").hide();
                this.$el.find("#SignUpWithAppleBtn").hide();
                this.$el.find("#SignUpWithOrganizationBtn").hide();
                this.$el.find("#showExternalSignupInfoWrapper").css("display","block");
                this.$el.find(fieldsToHideOrShow).show();
                this.emailField$el.focus();
            }
            this._syncAccessCodeFieldVisibility();
        },

        _setInlineAuthPrimaryEnabled : function(isEnabled){
            if(!this.signupInlineAuthPrimaryBtn$el){
                return;
            }

            this.signupInlineAuthPrimaryBtn$el.toggleClass("enabled", !!isEnabled);
            this.signupInlineAuthPrimaryBtn$el.toggleClass("disabled", !isEnabled);
            this.signupInlineAuthPrimaryBtn$el.attr("aria-disabled", isEnabled ? "false" : "true");
        },

        onInlineAuthFieldChanged : function(){
            if(!this._inlineAuthState){
                return;
            }

            const mode = this._inlineAuthState.mode;
            const emailValue = this.signupInlineAuthEmailField$el ? this.signupInlineAuthEmailField$el.val() : "";
            const codeValue = this.signupInlineAuthCodeField$el ? this.signupInlineAuthCodeField$el.val() : "";
            let isValid = false;

            if(mode === INLINE_AUTH_MODES.SSO_EMAIL){
                isValid = !!(emailValue && this.validateEmail(emailValue));
            }else if(mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
                isValid = !!(codeValue && codeValue.toString().trim());
            }

            this._setInlineAuthPrimaryEnabled(isValid);
        },

        clearInlineAuthError : function(){
            if(this.signupInlineAuthError$el){
                this.signupInlineAuthError$el.hide().text("");
            }
        },

        setInlineAuthError : function(message){
            if(this.signupInlineAuthError$el){
                this.signupInlineAuthError$el.text(message || "").toggle(!!message);
            }
        },

        closeInlineAuthFlow : function(){
            this._inlineAuthState = null;
            if(this.signupForm$el){
                this.signupForm$el.removeClass("authFlowModeActive");
            }
            if(this.signupInlineAuthPanel$el){
                this.signupInlineAuthPanel$el.hide();
            }
            this.clearInlineAuthError();
            if(this.signupInlineAuthEmailField$el){
                this.signupInlineAuthEmailField$el.val("");
            }
            if(this.signupInlineAuthCodeField$el){
                this.signupInlineAuthCodeField$el.val("");
            }
            this._setInlineAuthPrimaryEnabled(false);
        },

        openInlineAuthFlow : function(mode, options){
            const resolvedOptions = options || {};
            const email = resolvedOptions.email ? resolvedOptions.email.trim().toLowerCase() : "";
            let title = "";
            let description = "";
            let primaryLabel = "";
            let secondaryLabel = "";

            if(mode === INLINE_AUTH_MODES.SSO_EMAIL){
                title = window.getI18n(ti18n, "SIGN_UP_WITH_SSO");
                description = window.getI18n(ti18n, "ORGANIZATION_SIGNUP_PANEL_TEXT");
                primaryLabel = window.getI18n(ti18n, "CONTINUE_WITH_SSO");
                secondaryLabel = window.getI18n(ti18n, "BACK_TO_SIGN_UP");
            }else if(mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION){
                title = window.getI18n(ti18n, "EMAIL_VERIFICATION_PANEL_TITLE");
                description = window.getI18n(ti18n, "EMAIL_VERIFICATION_PANEL_TEXT").replace("%EMAIL%", email);
                primaryLabel = window.getI18n(ti18n, "EMAIL_VERIFICATION_VERIFY_BUTTON_LABEL");
                secondaryLabel = window.getI18n(ti18n, "BACK_TO_SIGN_UP");
            }

            this._inlineAuthState = {
                mode: mode,
                email: email,
                pendingAuthenticationToken: resolvedOptions.pendingAuthenticationToken || null,
            };
            if(this.signupForm$el){
                this.signupForm$el.addClass("authFlowModeActive");
            }

            this.signupInlineAuthTitle$el.text(title);
            this.signupInlineAuthDescription$el.text(description);
            this.signupInlineAuthPrimaryBtn$el.text(primaryLabel);
            this.signupInlineAuthSecondaryBtn$el.text(secondaryLabel);
            this.clearInlineAuthError();

            const shouldShowEmailField = mode === INLINE_AUTH_MODES.SSO_EMAIL;
            const shouldShowCodeField = mode === INLINE_AUTH_MODES.EMAIL_VERIFICATION;
            this.signupInlineAuthEmailFieldWrapper$el.toggle(shouldShowEmailField);
            this.signupInlineAuthCodeFieldWrapper$el.toggle(shouldShowCodeField);
            this.signupInlineAuthEmailField$el.val(shouldShowEmailField ? email : "");
            this.signupInlineAuthCodeField$el.val("");

            this.signupInlineAuthPanel$el.show();
            this.onInlineAuthFieldChanged();

            if(shouldShowEmailField){
                this.signupInlineAuthEmailField$el.focus();
            }else if(shouldShowCodeField){
                this.signupInlineAuthCodeField$el.focus();
            }
        },

        getInlineAuthData : function(){
            return {
                mode: this._inlineAuthState ? this._inlineAuthState.mode : null,
                email: this.signupInlineAuthEmailField$el && this.signupInlineAuthEmailField$el.is(":visible") ?
                    this.signupInlineAuthEmailField$el.val().trim().toLowerCase() :
                    (this._inlineAuthState && this._inlineAuthState.email ? this._inlineAuthState.email : ""),
                code: this.signupInlineAuthCodeField$el && this.signupInlineAuthCodeField$el.is(":visible") ?
                    this.signupInlineAuthCodeField$el.val().toString().trim() :
                    "",
                pendingAuthenticationToken: this._inlineAuthState ? this._inlineAuthState.pendingAuthenticationToken : null,
            };
        },



        onBeforeRemoveFromPage : function(){
            this.trigger("beforeRemoveFromPage", this);
            if(this._mousetrapObj){
                this._mousetrapObj.unbind("enter");
            }
        },

        onRemovedFromPage : function(){
            this.undelegateEvents();
            window.removeEventListener('resize', window[this._onViewportHeightChangedFunctionRef] );
            this.$el.removeData().unbind(); 
            this.trigger("removedFromPage", this);
        },

        onFieldValueChanged : function(event){
            if(this.isAllMandatoryFieldsFilled()){
                this.trebbleLogo$el.css("color",this._enabledColor);
                this.signUpBtn$el.removeClass("disabled").addClass("enabled");
            }else{
                this.trebbleLogo$el.css("color",this._disabledColor);
                this.signUpBtn$el.removeClass("enabled").addClass("disabled");
            }
        },
        isAllMandatoryFieldsFilled : function(){
            return this.usernameField$el.val() && this.validateUsername(this.usernameField$el.val())&& this.validatePasswordField() 
            //&& this.firstNameField$el.val() && this.emailField$el.val()
            && this.fullNameField$el.val() && this.emailField$el.val()
            && this.validateEmail(this.emailField$el.val())
            //&& this.lastNameField$el.val() //&& this.$el.find("#yearBirthdayField").val() 
            && (!this.isAccessCodeRequired()  || this._getCurrentAccessCode());
        },

        onUserNameFieldKeyUp :function(){
            this.usernameField$el.val( this.usernameField$el.val().replace(/ /g, "_").toLowerCase());
        },
        _onViewportHeightChanged : function(){
            const headerHeight = 54 ;
            this.$el.find(".ui-content").css("height",(window.getDocumentClienHeight() -headerHeight)+ "px");
        },



        validateEmail : function(email) {
            const re = Utils.getInstance().getEmailRegexValidation();
            return re.test(email? email.trim(): email);
        },


        validateUsername : function(username){
            const re = Utils.getInstance().getUsernameRegexValidation();
            return re.test(username);
        },

        validateReenterPasswordField : function(){
            const passwordDecorator = this.newPassswordFieldDec$el.get(0);
            const passwordInput = this.newPassswordField$el.get(0);
            const reenterPasswordDecorator = this.reenterNewPassswordFieldDec$el.get(0);
            const reenterPasswordInput =  this.reenterNewPassswordField$el.get(0);
            const pass2 = reenterPasswordInput.value;
            const pass1 = passwordInput.value;
            const arePasswordTheSame = pass1 === pass2;
            if (!arePasswordTheSame) {
                const errorMessage = window.getI18n(ti18n, "PASSWORD_DONT_MATCH");
                //reenterPasswordInput.setCustomValidity(errorMessage);
                this.reenterNewPassswordFieldDec$el.find("label").attr("data-error",errorMessage);
                if(!this.reenterNewPassswordField$el.hasClass("invalid"))
                {
                    this.reenterNewPassswordField$el.addClass("invalid");
                }
            } else {
                // empty string means no validation error
                this.reenterNewPassswordField$el.removeClass("invalid");
                //reenterPasswordInput.setCustomValidity('');
                this.reenterNewPassswordFieldDec$el.find("label").attr("data-error","");
            }
            //passwordDecorator.isInvalid = !passwordInput.validity.valid;
            //reenterPasswordDecorator.isInvalid = !reenterPasswordInput.validity.valid;
            return arePasswordTheSame;
        },

        validatePasswordField : function(){
            const passwordDecorator = this.newPassswordFieldDec$el.get(0);
            const passwordInput = this.newPassswordField$el.get(0);
            const pass1 = passwordInput.value;
            const re = Utils.getInstance().getUserPasswordRegexValidation();
            const isNewPasswordValid = re.test(pass1);
            if (!isNewPasswordValid) {
                const errorMessage = window.getI18n(ti18n, "PASSWORD_MUST_BE_BETWEEN_X_CHAR");
                //passwordInput.setCustomValidity(errorMessage);
                this.newPassswordFieldDec$el.find("label").attr("data-error",errorMessage);
                if(!this.newPassswordField$el.hasClass("invalid"))
                {
                    this.newPassswordField$el.addClass("invalid");
                }
            } else {
                // empty string means no validation error
                this.newPassswordField$el.removeClass("invalid");
                //passwordInput.setCustomValidity('');
                this.newPassswordFieldDec$el.find("label").attr("data-error","");
            }
            //passwordDecorator.isInvalid = !passwordInput.validity.valid;
            const reenterValid = DISABLE_PASSWORD_CONFIRM ?true: this.validateReenterPasswordField();
            return isNewPasswordValid && reenterValid;
        },

        _onPageShow : function(){
            if(this._hideBackButton){

                this.$el.find("#header-back-button").hide();
            }


        },

        _onGoogleSignupuccess : function(googleUser){
            this.trigger("signUpWithGoogleBtnSuccess",googleUser, this._getCurrentAccessCode());
        },

        _onGoogleSignupFailed : function(error){
            this.trigger("signUpWithGoogleBtnFailed",error);
        },

        /*_loadGAPI : function(){
            return new Promise((resolve, reject) => {
                window._loadScript('https://apis.google.com/js/client')
                  .then(() => {
                    // Check if the Google API client is available
                    if (typeof gapi !== 'undefined') {
                      // Assuming _onGAuthLoadedPromise is a global variable or defined elsewhere
                      // You can return it if it's available
                      resolve(_onGAuthLoadedPromise);
                    } else {
                      reject(new Error('Failed to load Google API client'));
                    }
                  })
                  .catch(reject);
              });

        },*/
        

        render : function(){
            const params ={};
            params.isUserpreviouslyLoggedInAsGuest = this.isUserpreviouslyLoggedInAsGuest;
            params.accessCode =  this._accessCode;
            params.loginForwardUrl = this._loginForwardUrl;
            params.ti18n = ti18n;
            params.showOrganizationLogin = this._showOrganizationLogin;
            params.showAppleAuthButtons = this.shouldShowAppleAuthButtons();
            this.$el.html(this.template(params));
            this.setElement(this.$el.find("div").first());

            this.$el.page();
            this.signupForm$el = this.$el.find("#SignUpForm");

            const functionUniqueGlobalName = "onViewportHeightChangeForSignupPage"+ (new Date()).getTime();
            window[functionUniqueGlobalName] =  this._onViewportHeightChanged.bind(this)
            this._onViewportHeightChangedFunctionRef = functionUniqueGlobalName;
            window.addEventListener('resize', window[functionUniqueGlobalName]  );
            this.usernameField$el = this.$el.find("#usernameField");
            this.newPassswordField$el = this.$el.find("#passwordField");
            this.reenterNewPassswordField$el = this.$el.find("#reenterPasswordField");
            this.newPassswordFieldDec$el = this.$el.find("#passwordDecId");
            this.reenterNewPassswordFieldDec$el = this.$el.find("#reenterPasswordDecId");
            this.emailField$el = this.$el.find("#emailField");
            this.firstNameField$el = this.$el.find("#firstNameField");
            this.lastNameField$el = this.$el.find("#lastNameField");
            this.fullNameField$el = this.$el.find("#fullNameField");
            this.fullNameFielDecorator$el = this.$el.find("#fullNameFieldDec");
            this.accessCodeField$el = this.$el.find("#accessCodeField");
            this.trebbleLogo$el =  this.$el.find(".icon-trebble-icon-2ton");
            this.signUpBtn$el = this.$el.find("#SignUpBtn");
            this.signupInlineAuthPanel$el = this.$el.find("#SignupInlineAuthPanel");
            this.signupInlineAuthTitle$el = this.$el.find("#SignupInlineAuthPanelTitle");
            this.signupInlineAuthDescription$el = this.$el.find("#SignupInlineAuthPanelDescription");
            this.signupInlineAuthError$el = this.$el.find("#SignupInlineAuthError");
            this.signupInlineAuthEmailFieldWrapper$el = this.$el.find("#SignupInlineAuthEmailFieldWrapper");
            this.signupInlineAuthCodeFieldWrapper$el = this.$el.find("#SignupInlineAuthCodeFieldWrapper");
            this.signupInlineAuthEmailField$el = this.$el.find("#SignupInlineAuthEmailField");
            this.signupInlineAuthCodeField$el = this.$el.find("#SignupInlineAuthCodeField");
            this.signupInlineAuthPrimaryBtn$el = this.$el.find("#SignupInlineAuthPrimaryBtn");
            this.signupInlineAuthSecondaryBtn$el = this.$el.find("#SignupInlineAuthSecondaryBtn");
            this.usernameField$el.on("click blur keyup input", this.onUserNameFieldKeyUp.bind(this));
            this.$el.find(".formField").on("click blur keyup input", this.onFieldValueChanged.bind(this));
            //this.$el.find("#SignUpWithFacebookBtn").hide();
            const shouldUseHostedSocialButtons = this.shouldUseHostedSocialAuthButtons();
            const shouldShowAppleAuthButtons = this.shouldShowAppleAuthButtons();
            if(!shouldShowAppleAuthButtons){
                this.$el.find("#SignUpWithAppleBtn").hide();
            }
            if(window.waitForCordovaToLoad ){
                if(shouldUseHostedSocialButtons){
                    if(shouldShowAppleAuthButtons){
                        this.$el.find("#SignUpWithAppleBtn").insertBefore(this.$el.find("#SignUpWithGoogleBtn"));
                    }
                    this.$el.find("#SignUpWithFacebookBtn").hide();
                }else if(window.isIOSMobileDevice && shouldShowAppleAuthButtons){
                    this.$el.find("#SignUpWithAppleBtn").insertBefore(this.$el.find("#SignUpWithFacebookBtn"))
                }else{
                    this.$el.find("#SignUpWithAppleBtn").hide();
                    this.$el.find("#SignUpWithGoogleBtn").insertBefore(this.$el.find("#SignUpWithFacebookBtn"))
                }
            }
            this.trebbleLogo$el.css("color",this._disabledColor);
            this.signUpBtn$el.removeClass("enabled").addClass("disabled");
            this.$el.on("pagehide", this._onPageHide.bind(this));
            this.$el.on("pageshow", this._onPageShow.bind(this));
            this._mousetrapObj = Mousetrap(this.$el.find("#SignUpForm").get(0)).bind('enter', (function(e, combo) {
                if(this.signUpBtn$el.hasClass("enabled")){
                    this.onSignUpBtnTapped();
                }
            }).bind(this));
            //this.$el.find("#reenterPasswordDecId").get(0).validate = this.validateReenterPasswordField.bind(this);
            //this.$el.find("#passwordDecId").get(0).validate = this.validatePasswordField.bind(this);

            this._syncAccessCodeFieldVisibility();
            this.$el.find("#SignUpWithGoogleBtn").hide();
            /*this._loadGAPI().then(function(){
                return _onGAuthLoadedPromise;
            }).then((function(){
                if(window.auth2 && window.auth2.attachClickHandler){
                    window.auth2.attachClickHandler(this.$el.find("#SignUpWithGoogleBtn").get(0), {},this._onGoogleSignupuccess.bind(this), this._onGoogleSignupFailed.bind(this));
                    this.$el.find("#SignUpWithGoogleBtn").show();
                }
            }).bind(this));*/

if(shouldUseHostedSocialButtons){
this.$el.find("#SignUpWithGoogleBtn").css("display","flex");
this.$el.find(".google_button_container").hide();
this.$el.find("#SignUpWithFacebookBtn").hide();
this.$el.find("#SignUpWithAppleBtn").css("display", shouldShowAppleAuthButtons ? "flex" : "none");
}else{
GooglePlusHelper.getInstance().attachClickHandlerToElementForLoginIntent(this.$el.find("#SignUpWithGoogleBtn").get(0), {},this._onGoogleSignupuccess.bind(this), this._onGoogleSignupFailed.bind(this), USE_NEW_GOOGE_API_ON_WEB, this.$el.find(".google_button_container").get(0),{text:"signup_with"}).then((function(){
if(USE_NEW_GOOGE_API_ON_WEB || window.isInMobileAppContext()){
this.$el.find("#SignUpWithGoogleBtn").css("display","flex");
}
}).bind(this));
}

this.showOrHideSignupOptions(true);
//this.$el.find("#emailField").focus();

return this;
},
setRemoveOnHide : function(removeOnHide){
this._removeOnHide =removeOnHide;
},

_onPageHide : function(){

if(this._removeOnHide)
{
//PersistentModels.getInstance().getRouter().unRegisterForViewportHeightChange(this._listenerViewportKey);
this.onBeforeRemoveFromPage();
this.remove();
this.onRemovedFromPage();
}
},



});
export default SignUpPageView;
